import React from 'react'
import { MDBTable, MDBTableBody } from 'mdbreact';
import BotonesFormulario from '../componentes/BotonesFormulario'
import HeaderTabla from '../componentes/HeaderTabla'
//import TraeNombre from '../hooks/useTraeNombre'
import { TraeNombre } from '../hooks/Funciones'

const VerReglas = ({ data, seleccionaRegistro, baseUrl, tiposIngresos }) => {

	return (
		<MDBTable hover responsive>
			<HeaderTabla array={['Nombre', 'Valor Mínima', 'Valor Máximo', 'Valor', '']} />
			<MDBTableBody>

				{data.map((item, index) => {
					return (
						<tr key={index} className="tabla_productos">
							<td>{item.nombre}</td>
							<td>{item.minimo}</td>
							<td>{item.maximo}</td>
							<td>${item.precio}</td>
							<td className="tabla_funciones">
								<BotonesFormulario SeleccionarCategoria={seleccionaRegistro} item={item} Roll={'Admin'} />
							</td>
						</tr>
					)
				})}

			</MDBTableBody>
		</MDBTable>
	)
}

export default VerReglas